/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from "./actionTypes";

const today = new Date();
const yyyy = today.getFullYear();
let mm = today.getMonth() + 1; // Months start at 0!
let dd = today.getDate() < 10 ? "0" + today.getDate() : today.getDate();
const currDate = mm + "/" + dd + "/" + yyyy;

const initilaState = {
  invoiceDetailsByInvoiceNum: {},
  handlingCodeValues: [],
  invoiceQuarter: [],
  invoiceStatusCodeValues: [],
  searchRequestMailing: {
    rebateProgramCode: "",
    addressTypeCode: "-1",
    planType: "",
    copies: 1,
    manufacturer: "All",
    invoiceMailedDate: currDate,
  },
  getManufacturerDetailsRequest: [],
  errorMessagesInRedux: [],
  fieldLevelErros: {},
  getCountOfAllMfgLabelsReq: "",
  getCountOfAllFilteredMfgLabelsReq: "",
  getAllMfgLabelsReq: ''
};

const reducer = (state = initilaState, action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_REBATE_PROGRAMS: {
      return { ...state, rebateProgramCode: action.payload };
    }
    case actionTypes.GET_ALL_ADDRESS_TYPE_CODE: {
      return { ...state, addressTypeCode: action.payload };
    }
    case actionTypes.SEARCH_MAILING_REQUEST: {
      return { ...state, searchRequestMailing: action.payload };
    }
    case actionTypes.HANDLE_HEADER_ERROR_MSG: {
      return { ...state, errorMessagesInRedux: action.errorMessagesInRedux };
    }
    case actionTypes.HANDLE_FIELD_LEVE_ERROR_MSG: {
      return { ...state, fieldLevelErros: action.fieldLevelErros };
    }
    case actionTypes.GET_REQUEST_MAILING_MANUFACTURER_DETAILS: {
      return {
        ...state,
        getManufacturerDetailsRequest: action.getManufacturerDetailsRequest
      };
    }
    case actionTypes.GET_COUNT_MGF_LABEL_REQUEST_LABEL: {
      return {
        ...state,
        getCountOfAllMfgLabelsReq: action.getCountOfAllMfgLabelsReq
      };
    }
    case actionTypes.GET_COUNT_FILTERED_MGF_LABEL_REQUEST_LABEL: {
      return {
        ...state,
        getCountOfAllFilteredMfgLabelsReq:
          action.getCountOfAllFilteredMfgLabelsReq
      };
    }
    case actionTypes.GET_MGF_LABEL_REQUEST_LABEL: {
      return {
        ...state,
        getAllMfgLabelsReq: action.getAllMfgLabelsReq
      };
    }
    default:
      return state;
  }
};

export default reducer;
